import { AppState } from "../AppState"

export const selectThumbnailById = (s: AppState, imageId?: string | null) =>
  imageId && s.thumbnail[imageId]

export const selectIsFetchingById = (s: AppState, imageId?: string | null) =>
  s.thumbnail.fetching.some((el) => el === imageId)
